import React, { useState } from "react";
import { Lock, Eye, EyeOff } from "lucide-react";

// Reusable password field with a show/hide (view) toggle.
const PasswordInput = ({ value, onChange, placeholder = "Password", autoFocus, showIcon = true, testId }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      {showIcon && <Lock className="w-4 h-4 text-white/40 absolute left-3 top-1/2 -translate-y-1/2" />}
      <input
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoFocus={autoFocus}
        data-testid={testId}
        className={`w-full bg-[#12131f] border border-white/10 rounded-lg ${showIcon ? "pl-10" : "pl-3"} pr-10 py-2.5 text-white text-sm outline-none focus:border-[#25D366] transition-colors`}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        tabIndex={-1}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/80 transition-colors"
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
};

export default PasswordInput;
